import request from "@/utils/request";
// 复赛学生展板信息和信息简表

//1,查询单个作品
export function getFinalFileDetail(data){
    return request({
        url:'/admin/FinalFile/detail',
        data:data,
        method:'get'
    })
}
//2,查询信息列表
export function getFinalFiles(data){
    return request({
        url:'/admin/FinalFile/list',
        data:data,
        method:'get'
    })
}

//1,删除信息
export function removeFinalFile(data){
    return request({
        url:'/admin/FinalFile/remove',
        data:data,
        method:'post'
    })
}
